module.exports = __webpack_public_path__ + "static/img/74072_R_20200811_LC.35b08bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/74072_R_20200811_LC.png
// module id = j8oh
// module chunks = 0